import * as React from "react";
import { useCallback, useState } from "react";
import { MessageBar, MessageBarType } from "@fluentui/react";
import { strings } from "@src/i18n/strings";

export const WIDE_PANE_TIP_STORAGE_KEY = "loadAgent.widePaneTipDismissed.v1";

const appStrings = strings.components.app;

const messageBarStyles = {
  root: { minHeight: "28px" },
  content: { alignItems: "center" },
  text: { margin: "4px 8px", fontSize: "12px" },
  icon: { margin: "6px 0 6px 8px" },
};

function readDismissed(): boolean {
  try {
    return window.localStorage.getItem(WIDE_PANE_TIP_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

/** One-time hint; Office.js can't set the task pane width, so we point users at Outlook's control. */
export default function WidePaneTip() {
  const [dismissed, setDismissed] = useState<boolean>(readDismissed);

  const dismiss = useCallback(() => {
    setDismissed(true);
    try {
      window.localStorage.setItem(WIDE_PANE_TIP_STORAGE_KEY, "1");
    } catch {
      // Best effort persistence only.
    }
  }, []);

  if (dismissed) return null;
  return (
    <MessageBar
      messageBarType={MessageBarType.info}
      onDismiss={dismiss}
      dismissButtonAriaLabel={appStrings.dismiss}
      styles={messageBarStyles}
    >
      {appStrings.widePaneTip}
    </MessageBar>
  );
}
